import { render, staticRenderFns } from "./Winning2.vue?vue&type=template&id=434f52b9&scoped=true&"
import script from "./Winning2.vue?vue&type=script&lang=js&"
export * from "./Winning2.vue?vue&type=script&lang=js&"
import style0 from "./Winning2.vue?vue&type=style&index=0&id=434f52b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f52b9",
  null
  
)

export default component.exports